import { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';

import { ModalFooter as CBModalFooter } from '@creditornot/cbt-modal';

import { ApiErrorNotification } from '../ApiErrorNotification';
import { Stack } from '../Stack';

export const Root = styled(CBModalFooter)`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
`;

export const Actions = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
`;

type Props = {
  className?: string;
  error?: Error | null;
  children?: ReactNode;
  justifyContentActions?: ComponentProps<typeof Stack>['justifyContent'];
  flexDirectionActions?: ComponentProps<typeof Stack>['direction'];
  gap?: ComponentProps<typeof Stack>['gap'];
};

export const ModalFooter = ({
  className,
  error,
  children,
  justifyContentActions,
  flexDirectionActions,
  gap = 'regularXlarge',
}: Props): React.ReactElement => {
  return (
    <Root className={className}>
      {error && <ApiErrorNotification error={error} />}
      <Stack
        alignItems="center"
        justifyContent={justifyContentActions || 'flex-end'}
        direction={flexDirectionActions || 'row'}
        gap={gap}
        wrap="wrap"
      >
        {children}
      </Stack>
    </Root>
  );
};
